// removed by extract-text-webpack-plugin
module.exports = {"Introduction":"src-components-DayInTheLife-Introduction----Introduction-module---Introduction---3FAYn","Introduction__Wrapper":"src-components-DayInTheLife-Introduction----Introduction-module---Introduction__Wrapper---1jWBt","Introduction__Media":"src-components-DayInTheLife-Introduction----Introduction-module---Introduction__Media---1SgGP","spacer":"src-components-DayInTheLife-Introduction----Introduction-module---spacer---1qm6P","Video":"src-components-DayInTheLife-Introduction----Introduction-module---Video---3FuA4"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DayInTheLife/Introduction/Introduction.module.scss
// module id = 720
// module chunks = 168000803916113